import PlainTextOfferMessageTheme from "css/themes/media-market/PlainTextOfferMessage.css";
import { bool, string } from "prop-types";
import React, { PureComponent } from "react";
import { Card } from "react-toolbox/lib/card";
import { H4, Small } from "visual-components/util/texts";

class DeclinedReasonMessage extends PureComponent {
  static propTypes = {
    content: string.isRequired,
    isSender: bool.isRequired,
  };

  render() {
    const { isSender, content } = this.props;

    const themes = {
      mainTheme: isSender
        ? PlainTextOfferMessageTheme.senderMain
        : PlainTextOfferMessageTheme.receiverMain,
    };

    return (
      <Card className={themes.mainTheme}>
        <div className={PlainTextOfferMessageTheme.container}>
          <div style={{ margin: "8px 0" }}>
            <H4>
              <i>Decline Reason</i>
            </H4>
          </div>
          <Small multiline>
            <span dangerouslySetInnerHTML={{ __html: content }} />
          </Small>
        </div>
      </Card>
    );
  }
}

export default DeclinedReasonMessage;
